<div class="filter-element">
  @if (searchMode) {
    <button (click)="closeSearch()" class="btn btn-outline-primary" type="button">
      <span translate>Close search</span>
    </button>
  }
</div>

<div class="filter-element">
  <div class="form-group mb-0" style="min-width: 280px;">

    <div class="input-group">
      <ng-select (change)="select($event)" (search)="onSearch($event.items)"
        [placeholder]="searchPlaceholder"
        id="searchItem">
        @for (item of searchItems; track item) {
          <ng-option [value]="item">
            @if (item.isFolder) {
              <span class="fa-solid fa-folder mr-2"></span>
            }
            @if (!item.isFolder) {
              <span class="fa-solid fa-file mr-2"></span>
            }
            <span [innerHtml]="item.name"></span>
          </ng-option>
        }
      </ng-select>

      <div class="input-group-append">
        <button (click)="displaySearchResult()" class="btn btn-outline-primary" id="button-addon2" type="button">
          <span class="fa-solid fa-magnifying-glass"></span>
        </button>
      </div>

    </div>
  </div>
</div>

<div class="filter-element">
  <div class="form-group mb-0">

    <div class="btn-group btn-group-toggle" ngbRadioGroup
      name="radioBasic">
      <label ngbButtonLabel class="btn btn-outline-primary"
        [class.active]="tileMode">
        <input ngbButton type="radio"
          (click)="selectLayout(bucketBrowserLayouts.TILE)">
          <span class="fa-solid fa-table-cells"></span>
          <span translate>Tiles</span>
        </label>
        <label ngbButtonLabel class="btn btn-outline-primary"
          [class.active]="listMode">
          <input ngbButton type="radio"
            (click)="selectLayout(bucketBrowserLayouts.LIST)">
            <span class="fa-solid fa-list"></span>
            <span translate>List</span>
          </label>
        </div>

      </div>
    </div>
